import { api } from 'dicomweb-client';
import { DICOMWeb } from '@ohif/core';

export default function searchStudySeries(server, studyInstanceUID) {
  const dicomWeb = new api.DICOMwebClient({
    url: server.qidoRoot,
    headers: DICOMWeb.getAuthorizationHeader(server),
  });

  return dicomWeb.searchForSeries({
    studyInstanceUID,
    queryParams: {
      includefield: '00080021,00080022,0008103E,00201209',
    },
  });
}
